import {PaginatedResponse} from './vte-api.service';
import {
    encodeSortColumnParam,
    sortDirectionForField as sharedSortDirectionForField,
    sortStateFromOrdering,
    toggleOrdering as sharedToggleOrdering,
    TableSortDirection,
} from '../../shared/utils/table-sort.utils';

export type VteListSortDirection = Exclude<TableSortDirection, ''>;

export type VteListState = {
    currentPage: number;
    pageSize: number;
    totalRecords: number;
    ordering: string;
    loading: boolean;
    nextPage: string | null;
    previousPage: string | null;
};

/** Empty ordering = backend default (API layers apply `-anchor_timestamp` / `-received_at`). */
export function createVteListState(ordering = '', pageSize = 10): VteListState {
    return {
        currentPage: 1,
        pageSize,
        totalRecords: 0,
        ordering,
        loading: false,
        nextPage: null,
        previousPage: null,
    };
}

export function totalPages(count: number, pageSize: number): number {
    return Math.max(1, Math.ceil(count / pageSize));
}

export function toggleOrdering(field: string, currentOrdering: string): string {
    return sharedToggleOrdering(field, currentOrdering);
}

export function sortDirectionForField(field: string, ordering: string): VteListSortDirection | null {
    return sharedSortDirectionForField(field, ordering);
}

export function orderingFromSortState(sortColumn: string, sortDirection: VteListSortDirection | ''): string {
    return encodeSortColumnParam({sortColumn, sortDirection});
}

export function sortStateFromVteOrdering(ordering: string) {
    return sortStateFromOrdering(ordering);
}

export function applyPaginatedResponse<T>(
    state: VteListState,
    response: PaginatedResponse<T>,
): void {
    state.totalRecords = response.count || 0;
    state.nextPage = response.next;
    state.previousPage = response.previous;
}
